import Grid from "@mui/material/Grid";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import { useContext, useEffect, useState } from "react";
import SchwingLogo from "../../../Images/Machines/Batching plant.png";
import SchwingLogoIndia from "../../../Images/Machines/Batching plant.png";
import dayjs from "dayjs";

const tableHeadings = [
  {
    bno: "Material",
    bdate: "Set Weight",
    cid: "Actual Weight",
    rid: "Difference in Kgs",
    qty: "Difference in %",
  },
];

const ConsuptionReport = ({ reportData, from, to }) => {
  const [pdfUrl, setPdfUrl] = useState(null);
  const [pdfUrlCh, setPdfUrlCh] = useState(null);
  const userId = "L3078";

  async function handleGeneratePDF() {
    const pdfDoc = await PDFDocument.create();
    const fontSize = 8.5;
    const pageWidth = 595;
    const pageHeight = 842;
    const title = sessionStorage.getItem("comp_name");
    const boldFont = await pdfDoc.embedFont(StandardFonts.HelveticaBold);
    const schwingIndia = "Schwing India";

    const fromDate = dayjs(from).format("DD-MM-YYYY");
    const toDate = dayjs(to).format("DD-MM-YYYY");

    const MainData = [];
    const data = [];
    for (let j in reportData.data) {
      MainData.push(reportData.data[j]);
      for (let k in MainData[j].data) {
        data.push(MainData[j].data[k]);
      }
    }

    //console.log(MainData);

    const x = 30;
    const y = pageHeight - (tableHeadings.length - 2) * fontSize;

    const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const pageCount = Math.ceil(data.length / 15);
    let rowY = pageHeight - (tableHeadings.length - 2) * fontSize;
    let rowY2 = y;
    let rowY3 = y;

    const imageBytes = await fetch(SchwingLogo).then((res) =>
      res.arrayBuffer(),
    );

    const image = await pdfDoc.embedPng(imageBytes);

    const imageBytes1 = await fetch(SchwingLogoIndia).then((res) =>
      res.arrayBuffer(),
    );

    const image1 = await pdfDoc.embedPng(imageBytes1);

    let logo, drawWidth, drawHeight;

    try {
      const imageUrl = "https://placehold.co/600x400/png"; // Get the image from sessionStorage

      if (!imageUrl)
        throw new Error("No image URL available in sessionStorage");

      const imageBytes = await fetch(imageUrl).then((res) => res.arrayBuffer());

      // Embed image based on its format
      if (imageUrl.includes("png")) {
        logo = await pdfDoc.embedPng(imageBytes);
      } else if (imageUrl.includes("jpeg") || imageUrl.includes("jpg")) {
        logo = await pdfDoc.embedJpg(imageBytes);
      } else {
        throw new Error(
          "Unsupported image format. Only PNG and JPG are allowed.",
        );
      }

      // Calculate dimensions
      const { width: imageWidth, height: imageHeight } = logo.scale(1);
      const aspectRatio = imageWidth / imageHeight;

      const targetWidth = userId === "L3078" ? 90 : "L3677" ? 50 : 110;
      const targetHeight = userId === "L3078" ? 50 : 75;

      if (aspectRatio >= 1) {
        drawWidth = targetWidth;
        drawHeight = targetWidth / aspectRatio;
      } else {
        drawHeight = targetHeight;
        drawWidth = targetHeight * aspectRatio;
      }
    } catch (error) {
      console.error("Error embedding logo:", error);
    }

    MainData.forEach((value) => {
      for (let i = 0; i < pageCount; i++) {
        const startIndex = i * 27;
        const endIndex = Math.min(startIndex + 27, data.length);
        const pageData = value.data.slice(startIndex, endIndex);

        if (pageData.length > 0) {
          rowY2 = 650;
          let page = pdfDoc.addPage([pageWidth, pageHeight]);
          let pageRowY = rowY2 + 12;

          for (const element of pageData) {
            page.drawText(element.mat_name.toString(), {
              x: x + 22,
              y: pageRowY,
              font,
              size: fontSize,
            });

            page.drawText(String(element?.mat_stwt).toString(), {
              x: x + 122,
              y: pageRowY,
              font,
              size: fontSize,
            });
            page.drawText(String(element?.mat_atwt).toString(), {
              x: x + 236,
              y: pageRowY,
              font,
              size: fontSize,
            });

            const diffKgs =
              Math.round((element.mat_atwt - element.mat_stwt) * 100) / 100;

            page.drawText(diffKgs.toString(), {
              x: x + 365,
              y: pageRowY,
              font,
              size: fontSize,
            });

            const diffPer =
              Math.round(
                ((element.mat_stwt - element.mat_atwt) / element.mat_stwt) *
                  100 *
                  100,
              ) / 100;

            page.drawText(diffPer.toString(), {
              x: x + 470,
              y: pageRowY,
              font,
              size: fontSize,
            });
            pageRowY -= 25;
          }

          page.drawText("Total Material Consumption Details", {
            x: 185,
            y: 775,
            size: 13,
            font,
          });

          page.drawText("Plant Sl No.:", {
            x: 50,
            y: 757,
            size: 12,
            font,
          });

          page.drawText(String(reportData?.p_sl), {
            x: 130,
            y: 757,
            size: 12,
            font,
          });

          page.drawText("Plant Name:", {
            x: 50,
            y: 740,
            size: 12,
            font,
          });

          page.drawText(String(reportData?.p_t), {
            x: 130,
            y: 740,
            size: 12,
            font,
          });
          page.drawText("From Time:", {
            x: 400,
            y: 757,
            size: 12,
            font,
          });

          page.drawText(fromDate.toString(), {
            x: 470,
            y: 757,
            size: 12,
            font,
          });
          page.drawText("To Time:", {
            x: 400,
            y: 740,
            size: 12,
            font,
          });
          page.drawText(toDate.toString(), {
            x: 470,
            y: 740,
            size: 12,
            font,
          });

          tableHeadings &&
            tableHeadings.forEach((header, rowIndex) => {
              rowY3 = y - (rowIndex + 20) * fontSize;
              rowY = y - (rowIndex + 16.2) * fontSize;

              page.drawText(value.cust_name.toString(), {
                x: x + 62,
                y: rowY,
                font,
                size: fontSize + 3,
              });
              page.drawText("Customer : ", {
                x: x,
                y: rowY,
                font,
                size: fontSize + 3,
              });

              page.drawText(header.bno.toString(), {
                x: x + 18,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.bdate.toString(), {
                x: x + 115,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.cid.toString(), {
                x: x + 227,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.rid.toString(), {
                x: x + 335,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
              page.drawText(header.qty.toString(), {
                x: x + 455,
                y: rowY3,
                font,
                size: fontSize + 2,
              });
            });

          const text = sessionStorage.getItem("comp_name");
          const textWidth = boldFont.widthOfTextAtSize(text, 15);
          const centerX = (pageWidth - textWidth) / 2;

          page.drawText(text, {
            x: centerX,
            y: 800,
            size: 15,
            font: boldFont,
          });

          if (sessionStorage.getItem("leftimage") === "1") {
            page.drawImage(image1, {
              x: 20,
              y: 790,
              width: 100,
              height: 40,
            });
          } else {
            page.drawImage(image, {
              x: 20,
              y: 800,
              width: 100,
              height: 30,
            });
          }

          //   if (sessionStorage.getItem("footer") !== "") {
          //     const maxWidth = page.getWidth(); // Get the full page width
          //     const fontSize = 10;
          //     const footerText = sessionStorage.getItem("footer");
          //     const lineHeight = 12;

          //     // Calculate yPos for footer
          //     const yPos = 40;

          //     // Draw a full-width horizontal line above the footer
          //     page.drawLine({
          //       start: { x: 10, y: yPos + 15 }, // Start from left edge
          //       end: { x: maxWidth - 10, y: yPos + 15 }, // End at right edge
          //       thickness: 1,
          //       color: rgb(0, 0, 0), // Black line
          //     });

          //     // Draw the footer text
          //     page.drawText(footerText, {
          //       x: 30,
          //       y: yPos,
          //       size: fontSize,
          //       font: boldFont,
          //       maxWidth: maxWidth - 60, // Adjust to avoid text overflow
          //       lineHeight: lineHeight,
          //     });
          //   }

          //   if (sessionStorage.getItem("logo") === "1" && logo) {
          //     const imgDims = logo.scale(1); // gets native width & height in points

          //     const targetWidth = 60;
          //     const aspectRatio = imgDims.height / imgDims.width;
          //     const targetHeight = targetWidth * aspectRatio;

          //     page.drawImage(logo, {
          //       x: 490,
          //       y: 780,
          //       width: targetWidth,
          //       height: targetHeight,
          //     });
          //   }

          page.drawLine({
            start: { x: 116, y: pageRowY + 18 },
            end: { x: 116, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 232, y: pageRowY + 18 },
            end: { x: 232, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 348, y: pageRowY + 18 },
            end: { x: 348, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });

          page.drawLine({
            start: { x: 464, y: pageRowY + 18 },
            end: { x: 464, y: rowY3 + 13.5 },
            thickness: 0.1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: rowY3 - 5 },
            end: { x: 570, y: rowY3 - 5 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: rowY3 + 13 },
            end: { x: 570, y: rowY3 + 13 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 570, y: rowY3 + 13.5 },
            end: { x: 570, y: pageRowY + 18 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: rowY3 + 13.5 },
            end: { x: 25, y: pageRowY + 18 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
          page.drawLine({
            start: { x: 25, y: pageRowY + 18 },
            end: { x: 570, y: pageRowY + 18 },
            thickness: 1,
            color: rgb(0.5, 0.5, 0.5),
            opacity: 0.75,
          });
        }
      }
    });

    // Save the PDF
    const pdfBytes = await pdfDoc.save();

    setPdfUrlCh(
      URL.createObjectURL(new Blob([pdfBytes], { type: "application/pdf" })),
    );
  }

  useEffect(() => {
    if (reportData) {
      handleGeneratePDF();
    }
  }, [reportData]);

  return (
    <Grid container spacing={2} alignItems='center'>
      {reportData && (
        <iframe
          src={pdfUrlCh}
          width='100%'
          height='600px'
          title='Batch Report PDF'
        />
      )}
    </Grid>
  );
};

export default ConsuptionReport;
